import { render, staticRenderFns } from "./RListHeader.vue?vue&type=template&id=2e49e2a6&scoped=true"
import script from "./RListHeader.vue?vue&type=script&lang=js"
export * from "./RListHeader.vue?vue&type=script&lang=js"
import style0 from "./RListHeader.vue?vue&type=style&index=0&id=2e49e2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e49e2a6",
  null
  
)

export default component.exports